import {Component, effect, EventEmitter, Input, Output, signal, Signal} from '@angular/core';
import {NbButtonModule, NbDialogService, NbIconModule, NbSpinnerModule} from "@nebular/theme";
import {Utils} from "../../../../shared/utils";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {debounceTime, interval, Subscription} from "rxjs";
import {GamesService} from "../../../../services/games-service.service";
import {OrganizeMatchFormComponent} from "./organize-match-form/organize-match-form.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-organize',
  standalone: true,
  imports: [
    TranslateModule,
    NbButtonModule,
    ReactiveFormsModule,
    NbIconModule,
    NbSpinnerModule
  ],
  templateUrl: './organize.component.html',
  styleUrl: './organize.component.scss'
})
export class OrganizeComponent {
  private obs: Subscription = new Subscription();
  private sub!: Subscription;

  searchTeam: string = '';
  selectedDivisionId: string | undefined;
  selectedGroupId: string | undefined;
  searchForm: FormGroup = new FormGroup({search_team: new FormControl()});

  private refreshTick = signal(0);
  loading = signal<boolean>(false);
  organizeGameTeams = signal<any>({});

  @Input() selectedDivisionIdSignal = signal<string>('');
  @Input() selectedGroupIdSignal = signal<string>('A');
  @Input() selectedGroupName!: Signal<any>;
  @Input() selectedDivisionName!: Signal<any>;
  @Output() onMatchUpdate = new EventEmitter<any>();

  constructor(public utils: Utils, private gamesService: GamesService, private dialogService: NbDialogService) {
    effect(() => {
      this.refreshTick();
      this.selectedGroupIdSignal();
      this.search();
    }, { allowSignalWrites: true });
  }

  ngOnInit() {
    this.obs = this.searchForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.searchTeam = data.search_team;
        this.search();
      });

    // ⏱ Rafraîchissement toutes les minutes
    this.sub = interval(120_000).subscribe(() => {
      this.search();
    });
  }

  ngOnDestroy() {
    this.obs.unsubscribe();
    this.sub.unsubscribe();
  }

  search() {
    this.loading.set(true);
    this.gamesService.listTeamsForOrganizeGame(this.selectedDivisionIdSignal(), this.selectedGroupIdSignal(), 1, 1000, this.searchTeam).subscribe((teams: any) => {
      this.organizeGameTeams.set(teams);
      this.loading.set(false);
    });
  }

  openOrganizeForm(selectedDivisionIdSignal: any, selectedGroupIdSignal: any, selectedOpponentTeam: any) {
    this.dialogService.open(OrganizeMatchFormComponent, {
      context: {
        selectedDivisionIdSignal: selectedDivisionIdSignal,
        selectedGroupIdSignal: selectedGroupIdSignal,
        selectedOpponentTeam: selectedOpponentTeam,
      },
    }).onClose.subscribe(() => {
      this.onMatchUpdate.emit('by_organize');
      this.search();
    });
  }
}
